module.exports = __webpack_public_path__ + "static/media/icon_check_filter.91ad4610.svg";